import React from 'react';
import { useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';
import { apiGet } from 'services';

export const OAuthShowpad = ({ location, history }) => {
    const guid = useSelector(state => state.user.user.guid);
    const [error, setError] = React.useState('');

    const values = queryString.parse(location.search);
    if (values.code) {
        apiGet(
            `showpad-accesscode/${values.code}`,
            guid,
            response => {
                if (!response.error) {
                    history.replace('/admin/integrations');
                } else {
                    setError(response.error_Description);
                }
            },
            null
        );
    }

    return error ? `Error: ${error}` : 'Loading Showpad API Details...';
};

export default withRouter(OAuthShowpad);
